export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const MONTH_NAME_OPTIONS = MONTH_NAMES.map((name, index) => ({
  value: index + 1,
  label: name,
}));
